<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-mapper drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-mapper" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          Mapper
        </font>
        <v-spacer></v-spacer>
        <!-- <v-btn
          class="btn btn-save rounded-xl mr-2"
          disabled
          v-if="!isHistory"
          @click="save"
          >{{ $t("btn.common.save") }}</v-btn
        >
        <v-btn
          class="btn btn-delete rounded-xl mr-2"
          disabled
          v-if="!isHistory"
          >{{ $t("btn.common.delete") }}</v-btn
        > -->
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="8" class="pl-3 pr-2 py-0">
          <v-label class="pt-2">{{ $t('lbl.mapManager.mapLayout.mapName') }}</v-label>
          <v-autocomplete
            v-model="comId"
            :items="mapList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="MAP_PRCS_NO"
            item-text="MAPPINGNAME"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="4" class="pr-3 pl-2 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.mapManager.mapLayout.message') }}
          </v-label>
          <v-autocomplete
            v-model="addMapFileLayoutHeader.data[0].MAP_MSG_ID"
            :items="EDIMesList"
            :menu-props="{ offsetY: true }"
            :rules="[validationUtils.required]"
            ref="refMessage"
            :disabled="!$auth.manage"
            readonly
            solo
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.value }}
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="4" class="pl-3 pr-2 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.mapManager.mapLayout.mapType') }}
          </v-label>
          <v-select
            v-model="map_type_from"
            @change="filterMapType"
            :items="codeItem"
            :menu-props="{ offsetY: true }"
            :rules="[validationUtils.required]"
            ref="refMapTypeForm"
            :disabled="!$auth.manage"
            readonly
            solo
          >
          </v-select>
        </v-col>
        <v-col cols="12" md="4" class="pl-2 pr-2 py-0">
          <v-label>
            {{ $t('lbl.mapManager.mapLayout.to') }}
          </v-label>
          <v-select
            v-model="map_type_to"
            :items="codeItem"
            :menu-props="{ offsetY: true }"
            :rules="[validationUtils.required]"
            ref="refMapTypeTo"
            :disabled="!$auth.manage"
            readonly
            solo
          >
          </v-select>
        </v-col>
        <v-col cols="12" md="4" class="pr-3 pl-2 py-0" ref="eDI_version">
          <v-label>
            <v-icon x-small v-if="this.icon" class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.mapManager.mapLayout.ediVersion') }}
          </v-label>
          <v-autocomplete
            v-if="this.icon"
            v-model="addMapFileLayoutHeader.data[0].MAP_MSG_VER"
            :items="EDIVesionList"
            :menu-props="{ offsetY: true }"
            :rules="[validationUtils.required]"
            ref="refEdiVersion"
            :disabled="!$auth.manage"
            readonly
            solo
          >
          </v-autocomplete>
          <v-autocomplete
            v-if="!this.icon"
            v-model="addMapFileLayoutHeader.data[0].MAP_MSG_VER"
            :items="EDIVesionList"
            :menu-props="{ offsetY: true }"
            ref="refEdiVersion"
            :disabled="!$auth.manage"
            readonly
            solo
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="12" class="pl-3 pr-3 py-0">
          <v-label>
            <v-icon v-if="options.item.action == 'add'" x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.mapManager.mapLayout.mapperFile') }}
          </v-label>
        </v-col>
        <v-col v-if="options.item.action !== 'add'" cols="12" md="12" class="pl-3 pr-3 py-0">
          <v-text-field
            v-model="addMapFileLayoutHeader.data[0].MAPPER_NAME"
            :disabled="!$auth.manage"
            readonly
            solo
          ></v-text-field>
          <input
            id="mapfile_layout_input"
            type="file"
            ref="mapfile_layout_input"
            style="display: none"
          />
        </v-col>
        <v-col
          v-if="options.item.action == 'add'"
          cols="12"
          :md="isDlb ? 6 : 10"
          class="pl-3 pr-2 py-0"
        >
          <v-text-field
            v-model="addMapFileLayoutHeader.data[0].MAPPER_NAME"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            readonly
            solo
          ></v-text-field>
          <input
            @change="onFlatFileChanged"
            id="mapfile_layout_input"
            type="file"
            ref="mapfile_layout_input"
            style="display: none"
          />
        </v-col>
        <v-col v-if="options.item.action == 'add' && isDlb" cols="12" md="4" class="pl-2 pr-2 py-0">
          <v-select
            v-model="libraryVersion"
            @change="onVersionChange(libraryVersion)"
            :items="libraryItem"
            :rules="[validationUtils.required]"
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            readonly
            ref="refMapTypeTo"
            solo
          >
          </v-select>
        </v-col>
        <v-col
          cols="12"
          v-if="options.item.action == 'add'"
          md="2"
          class="py-0 pr-3 pl-2 text-right"
        >
          <v-btn
            class="btn btn-load"
            color="primary"
            :disabled="$cookies.get('comp-id') !== $cookies.get('ownr-id')"
            @click="openLoadFilePop({ mode: 'Load', filetype: 'mapper' })"
          >
            {{ $t('btn.mapManager.load') }}
          </v-btn>
        </v-col>
        <v-col v-if="isDlb" cols="12" md="12" class="pl-3 pr-3 py-0">
          <div class="layout-chkin-color_u">
            <a
              @click="
                $cookies.get('comp-id') === $cookies.get('ownr-id') ? openCodeTableDialog() : null
              "
              >{{ selectCodeName }}</a
            >
            <a v-if="codelistFlag" class="pl-3" @click="downloadCodeList(selectCodeId)">{{
              $t('tbl.mapManager.versionHistory.download1')
            }}</a>
          </div>
        </v-col>
        <v-col v-else cols="12" md="12" class="pl-3 pr-3 py-0">
          <div class="layout-chkin-color_u">
            <a
              @click="
                $cookies.get('comp-id') === $cookies.get('ownr-id') ? openCodeTableDialog() : null
              "
              >{{ selectCodeName }}</a
            >
          </div>
        </v-col>
        <v-col cols="12" md="12" class="pr-3 pl-3 py-0">
          <v-label>
            <v-icon x-small v-if="options.item.action === 'add'" class="mr-1"
              >fa fa-asterisk</v-icon
            >
            {{ $t('lbl.mapManager.mapLayout.comment') }}
          </v-label>
          <v-text-field
            v-if="options.item.action === 'add'"
            v-model="addMapFileLayoutHeader.data[0].MAPPER_COMT"
            :rules="[validationUtils.required]"
            ref="refMapperComt"
            :disabled="!$auth.manage"
            :readonly="(options.item.action == 'add' ? false : true) || isHistory"
            solo
          ></v-text-field>
          <v-text-field
            v-if="options.item.action != 'add'"
            v-model="addMapFileLayoutHeader.data[0].MAPPER_COMT"
            readonly
            solo
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="pr-3 pl-3 py-0">
          <v-label>
            {{ $t('lbl.mapManager.mapLayout.scannerFile') }}
          </v-label>
        </v-col>
        <v-col
          cols="12"
          :md="options.item.action == 'add' && disable_Scan ? '10' : '12'"
          :class="['py-0', options.item.action == 'add' && disable_Scan ? 'pr-2 pl-3' : 'px-3']"
        >
          <v-text-field
            v-if="options.item.action != 'add'"
            v-model="addMapFileLayoutHeader.data[0].SCANNER_NAME"
            readonly
            solo
          ></v-text-field>
          <input
            v-if="options.item.action != 'add'"
            id="scanfile_layout_input"
            type="file"
            ref="scanfile_layout_input"
            style="display: none"
          />
          <v-text-field
            v-if="options.item.action == 'add'"
            v-model="addMapFileLayoutHeader.data[0].SCANNER_NAME"
            solo
            readonly
          ></v-text-field>
          <input
            v-if="options.item.action == 'add'"
            id="scanfile_layout_input"
            type="file"
            ref="scanfile_layout_input"
            style="display: none"
            @change="onCsvFileChanged"
          />
        </v-col>
        <v-col
          cols="12"
          v-if="options.item.action == 'add' && disable_Scan"
          md="2"
          class="py-0 pr-3 pl-2 text-right"
        >
          <v-btn
            class="btn btn-load"
            color="primary"
            :disabled="$cookies.get('comp-id') !== $cookies.get('ownr-id')"
            @click="openLoadFilePop({ mode: 'Load', filetype: 'scanner' })"
          >
            {{ $t('btn.mapManager.load') }}
          </v-btn>
        </v-col>
        <v-col cols="12" md="12" class="pr-3 pl-3 py-0">
          <v-label>
            {{ $t('lbl.mapManager.mapLayout.comment') }}
          </v-label>
          <v-text-field
            v-model="addMapFileLayoutHeader.data[0].SCANNER_COMT"
            :disabled="!$auth.manage"
            :readonly="disable_comment || isHistory"
            solo
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="py-0 pr-3 pl-3">
          <v-label>
            {{ $t('lbl.mapManager.mapLayout.flatFileLayout') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="10" class="pl-3 pr-2 py-0">
          <v-text-field
            v-model="addMapFileLayoutHeader.data[0].FFL_FILE_NAME"
            readonly
            solo
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="py-0 pr-3 pl-2 text-right">
          <v-btn
            class="btn btn-load"
            color="primary"
            :disabled="$cookies.get('comp-id') !== $cookies.get('ownr-id')"
            @click="openFlatFileLayoutList()"
          >
            {{ $t('btn.mapManager.load') }}
          </v-btn>
        </v-col>
        <v-col cols="12" md="12" class="py-0 pr-3 pl-3">
          <v-label>
            {{ $t('lbl.mapManager.mapLayout.mappingDefinition') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="10" class="pl-3 pr-2 py-0">
          <v-text-field v-model="mapDefinitionFileName" readonly solo></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="py-0 pr-3 pl-2 text-right">
          <v-btn
            class="btn btn-load"
            color="primary"
            :disabled="$cookies.get('comp-id') !== $cookies.get('ownr-id')"
            @click="openMappingDefinitionList()"
          >
            {{ $t('btn.mapManager.load') }}
          </v-btn>
        </v-col>
        <v-col cols="12" v-if="mapVersion">
          <a
            class="link-file-text expand-collapse-text"
            @click="
              $cookies.get('comp-id') === $cookies.get('ownr-id') ? openMapperVersion() : null
            "
            >Version {{ mapVersion }}</a
          >
        </v-col>
      </v-row>
    </v-form>

    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Mapper', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Mapper', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="deleteFltr"
      title="Delete Mapper"
      size="max"
      :detail="$t('lbl.processSetup.delComponent', ['mapper'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="actionDel()"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import cfg from '@/vue-caas/config/config.js';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  computed: {
    ...mapState('mapbuilder', {
      libList: 'libList',
    }),
    ...mapState('common', {
      EDIVerList: 'EDIVerList',
      /* 2020/11/06 203737 Remove unused source
        EDIMsgTypeList:"EDIMsgTypeList",*/
      CommMsgList: 'CommMsgList',
      codeList: 'codeList',
      repomenuMode: 'repomenuMode',
    }),
    ...mapState('map', {
      mapList: 'mapListSMLK',
      mapData: 'mapData',
      codeListResult: 'codeListResult',
    }),
    /* 2020/11/06 203737 Remove unused source
    ...mapState("common", {
      fileContent: "fileContent",
    }),*/
    disable_comment() {
      if (this.options.item.action == 'add') {
        if (this.disable_Scan == false) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'MAP',
      dropable: true,
      mode: '',
      filetype: '',
      selectCodeName: this.$t('lbl.mapBuilder.builderCheckIn.codeCovertingTable'),
      selectCodeId: '',
      fileLoaded: '',
      scannerLoaded: '',
      ACCESS_REPO_YN: '', // common mandatory for ADMIN_YN
      /* 2020/11/06 203737 Remove unused source
      value: null,*/
      icon: false,
      mandatoryField: false,
      contenInput: '',
      disable_Scan: true,
      /* 2020/11/06 203737 Remove unused source
      add_valid_str: '',*/
      map_type_from: '',
      map_type_to: '',
      mapDefinitionFileName: '',
      codelistFlag: false,
      /* 2020/11/06 203737 Remove unused source
      item: {
        flatfile: '',
        mapDefinitionFile:'',
        comment: '',
        csv_file: ''
      },*/
      mapConVersionType: [],
      /* 2020/11/06 203737 Remove unused source
      businessNameList: [{
        text: 'text',
        value: 'value'
      }],
      typeList: ['text'],*/
      modifyMap: {
        header: ['MAP_PRCS_NO'],
        data: [
          {
            MAP_PRCS_NO: '',
          },
        ],
      },
      addMapFileLayoutHeader: {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'MAP_CONV_TP',
          'MAP_MSG_VER',
          'MAP_MSG_ID',
          'MAP_NAME',
          'FFL_PRCS_NO',
          'MPD_PRCS_NO',
          'MAPPER_NAME',
          'MAPPER_FILE_ID',
          'MAPPER_SIZE',
          'MAPPER_COMT',
          'SCANNER_NAME',
          'SCANNER_FILE_ID',
          'SCANNER_SIZE',
          'SCANNER_COMT',
          'FFL_FILE_NAME',
          'CODE_CTG_ID',
          'LIB_VER',
          'ORA_VER',
          'TARGET_MAPPER_ID',
          'TARGET_MAPPER_NAME',
          'TARGET_SCANNER_ID',
          'TARGET_SCANNER_NAME',
          'mappfile',
          'scanfile',
        ],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            OWNR_CUST_ID: '',
            MAP_CONV_TP: '',
            MAP_MSG_VER: '',
            MAP_MSG_ID: '',
            MAP_NAME: '',
            FFL_PRCS_NO: '',
            MPD_PRCS_NO: '',
            MAPPER_NAME: '',
            MAPPER_FILE_ID: '',
            MAPPER_SIZE: '',
            MAPPER_COMT: '',
            SCANNER_NAME: '',
            SCANNER_FILE_ID: '',
            SCANNER_SIZE: '',
            SCANNER_COMT: '',
            FFL_FILE_NAME: '',
            CODE_CTG_ID: '',
            LIB_VER: '',
            ORA_VER: '',
            TARGET_MAPPER_ID: '',
            TARGET_MAPPER_NAME: '',
            TARGET_SCANNER_ID: '',
            TARGET_SCANNER_NAME: '',
            mappfile: null,
            scanfile: null,
          },
        ],
      },
      updateMapFileLayoutHeader: {
        header: [
          'MAP_PRCS_NO',
          'MAP_CONV_TP',
          'MAP_MSG_VER',
          'MAP_MSG_ID',
          'MAP_NAME',
          'FFL_PRCS_NO',
          'CODE_CTG_ID',
          'MPD_PRCS_NO',
        ],
        data: [
          {
            MAP_PRCS_NO: '',
            MAP_CONV_TP: '',
            MAP_MSG_VER: '',
            MAP_MSG_ID: '',
            MAP_NAME: '',
            FFL_PRCS_NO: '',
            CODE_CTG_ID: '',
            MPD_PRCS_NO: '',
          },
        ],
      },
      EDIVesionList: [{ text: 'Type', value: '' }],
      EDIMesList: [{ text: 'Type', value: '' }],
      codeItem: [{ text: 'Type', value: '' }],
      EDIVesionSearchItems: {
        header: ['PARAM'],
        data: [
          {
            PARAM: '',
          },
        ],
      },
      /* 2020/11/06 203737 Remove unused source
      EDIMsgTypeListSearchItems: {
        header: ['MSG_VER'],
        data: [{
          MSG_VER:'',
        }],
      },*/
      codeSearchItems: {
        header: ['GRP_CODE'],
        data: [
          {
            GRP_CODE: '',
          },
        ],
      },
      librarySearchItem: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      codeListCreate: {
        header: ['CODE_CTG_ID', 'DIV_KUBUN', 'SITE_CODE', 'SUB_DIR'],
        data: [
          {
            CODE_CTG_ID: '',
            DIV_KUBUN: 'ASSET',
            SITE_CODE: '',
            SUB_DIR: '',
          },
        ],
      },
      libraryItem: [{ text: 'Compile library', value: '' }],
      libraryVersion: '',
      oracleVersion: '',
      isDlb: false,
      mapVersion: '',
      mapHistory: {},
    };
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  mounted() {
    setTimeout(() => {
      // this.$refs.refMapName.focus();
    }, 300);
  },
  watch: {
    mandatoryField() {
      if (this.mandatoryField) {
        this.$refs.eDI_version.classList.add('mandatory');
        this.icon = true;
      }
    },
  },
  methods: {
    changeComponentData() {
      this.changeMapper(this.comId);
    },
    openMapperVersion() {
      EventBus.$emit('open-map-version', this.mapHistory);
    },
    resetForm() {
      this.addMapFileLayoutHeader = {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'MAP_CONV_TP',
          'MAP_MSG_VER',
          'MAP_MSG_ID',
          'MAP_NAME',
          'FFL_PRCS_NO',
          'MPD_PRCS_NO',
          'MAPPER_NAME',
          'MAPPER_FILE_ID',
          'MAPPER_SIZE',
          'MAPPER_COMT',
          'SCANNER_NAME',
          'SCANNER_FILE_ID',
          'SCANNER_SIZE',
          'SCANNER_COMT',
          'FFL_FILE_NAME',
          'CODE_CTG_ID',
          'LIB_VER',
          'ORA_VER',
          'TARGET_MAPPER_ID',
          'TARGET_MAPPER_NAME',
          'TARGET_SCANNER_ID',
          'TARGET_SCANNER_NAME',
          'mappfile',
          'scanfile',
        ],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            OWNR_CUST_ID: '',
            MAP_CONV_TP: '',
            MAP_MSG_VER: '',
            MAP_MSG_ID: '',
            MAP_NAME: '',
            FFL_PRCS_NO: '',
            MPD_PRCS_NO: '',
            MAPPER_NAME: '',
            MAPPER_FILE_ID: '',
            MAPPER_SIZE: '',
            MAPPER_COMT: '',
            SCANNER_NAME: '',
            SCANNER_FILE_ID: '',
            SCANNER_SIZE: '',
            SCANNER_COMT: '',
            FFL_FILE_NAME: '',
            CODE_CTG_ID: '',
            LIB_VER: '',
            ORA_VER: '',
            TARGET_MAPPER_ID: '',
            TARGET_MAPPER_NAME: '',
            TARGET_SCANNER_ID: '',
            TARGET_SCANNER_NAME: '',
            mappfile: null,
            scanfile: null,
          },
        ],
      };
      this.addMapFileLayoutHeader.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
      this.addMapFileLayoutHeader.data[0].CUST_ID = $cookies.get('comp-id');
      this.addMapFileLayoutHeader.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
      this.mapVersion = '';
      this.mapHistory = {};
      this.map_type_to = '';
      this.map_type_from = '';
      this.mapDefinitionFileName = '';
      this.selectCodeName = this.$t('lbl.mapBuilder.builderCheckIn.codeCovertingTable');
      this.selectCodeId = '';
      this.codelistFlag = false;
      this.mandatoryField = false;
      EventBus.$emit('change-component-data', '', this.nodeId);
    },
    initialize() {
      if (this.options.item.data.comId) {
        this.options.item.action = 'modify';
      } else {
        this.options.item.action = 'add';
      }
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.codelistFlag = false;
      // By April to Show EDI Asset depending on Authority.
      // Check whether entered from repository menu on top selection of customer or User menu
      if (this.repomenuMode) {
        // Repository Menu
        if ($cookies.get('comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY';
        // CLT Super Provider
        else this.ACCESS_REPO_YN = 'YN'; // Normal User Admin
      } else {
        // Normal User
        this.ACCESS_REPO_YN = 'NN';
      }
      this.addMapFileLayoutHeader.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
      this.addMapFileLayoutHeader.data[0].CUST_ID = $cookies.get('comp-id');
      this.addMapFileLayoutHeader.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
      this.changeMapper(this.options.item.data.comId);
      this.contenInput = '';
      this.getEDIVesion();
      this.getEDIMsgTypeList();
      this.getCode();
      this.mapConVersionType = this.codeItem;
      this.isDlb = cfg.isDlb;
      this.getLibraryVersion();
    },
    changeMapper(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (id && (this.manage || this.isHistory)) {
        let count = 0;
        let usedList = [];
        $('.proc-component.v-card.v-sheet').each(function() {
          let comp = $(this)[0].__vue__.$parent;
          if (comp.comTp == 'MAP' && comp.mapperId === id) {
            count += 1;
            usedList.push(comp.nodeId);
          }
        });
        // 193557 Map Manager fix issue 11,13
        this.modifyMap.data[0].MAP_PRCS_NO = id;
        Store.dispatch('map/getMapInfo', this.modifyMap).then(() => {
          console.log('--------- Finished to process ----------');
          this.addMapFileLayoutHeader.data[0].MAP_NAME = this.mapData[0].MAP_NAME;
          this.addMapFileLayoutHeader.data[0].MAP_CONV_TP = this.mapData[0].MAP_CONV_TP;
          this.addMapFileLayoutHeader.data[0].MAPPER_NAME = this.mapData[0].MAPPER_NAME;
          this.addMapFileLayoutHeader.data[0].MAPPER_COMT = this.mapData[0].MAPP_COMT;
          this.addMapFileLayoutHeader.data[0].SCANNER_NAME = this.mapData[0].SCANNER_NAME;
          this.addMapFileLayoutHeader.data[0].SCANNER_COMT = this.mapData[0].SCAN_COMT;
          this.addMapFileLayoutHeader.data[0].FFL_FILE_NAME = this.mapData[0].FFL_FILE_NAME;
          this.addMapFileLayoutHeader.data[0].FFL_PRCS_NO = this.mapData[0].FFL_PRCS_NO;
          this.addMapFileLayoutHeader.data[0].MPD_PRCS_NO = this.mapData[0].MPD_PRCS_NO;
          this.addMapFileLayoutHeader.data[0].MAP_PRCS_NO = this.mapData[0].MAP_PRCS_NO;
          this.addMapFileLayoutHeader.data[0].MAP_MSG_VER = this.mapData[0].MAP_MSG_VER;
          this.addMapFileLayoutHeader.data[0].MAP_MSG_ID = this.mapData[0].MAP_MSG_ID;
          this.map_type_to = this.mapData[0].MAP_CONV_TP_TO;
          this.map_type_from = this.mapData[0].MAP_CONV_TP_FROM;
          this.mapDefinitionFileName = this.mapData[0].MPD_FILE_NAME;
          this.comId = this.mapData[0].MAP_PRCS_NO;
          if (this.mapData[0].CODE_CTG_ID != null) {
            this.selectCodeName = this.mapData[0].CODE_CTG_NAME;
            this.selectCodeId = this.mapData[0].CODE_CTG_ID;
            this.codelistFlag = true;
          }

          if (this.map_type_from == 'E' || this.map_type_from == 'A') {
            this.mandatoryField = true;
          } else {
            this.mandatoryField = false;
          }
        });
        for (let i = 0; i < this.mapList.length; i++) {
          if (this.mapList[i].MAP_PRCS_NO === id) {
            this.mapVersion = `${this.mapList[i].MAPP_VER}`;
            this.mapHistory = {
              MAPP_VER: `${this.mapList[i].MAPP_VER}`,
              MAPPER_NAME: `${this.mapList[i].MAPPER_NAME}`,
              MAP_PRCS_NO: `${this.mapList[i].MAP_PRCS_NO}`,
              MAP_CONV_TP: `${this.mapList[i].MAP_CONV_TP}`,
              CODE_CTG_ID: `${this.mapList[i].CODE_CTG_ID}`,
              MAP_UPD_USR: `${this.mapList[i].MAP_UPD_USR}`,
              MAP_MAPP_CHKIN_YN: `${this.mapList[i].MAP_MAPP_CHKIN_YN}`,
              HIDE_CHECK_IN: true,
            };
          }
        }
        if (count > 0 && !usedList.includes(this.nodeId)) {
          this.$nextTick(() => {
            EventBus.$emit('change-component-data', '', this.nodeId);
          });
        } else {
          EventBus.$emit('change-component-data', id, this.nodeId);
        }
      } else {
        this.resetForm();
      }
    },
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('mapbuilder/queryLibraryList', this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if (this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE,
            });
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE,
              });
            }
          }
        }
        this.libraryVersion = this.libraryItem[0].value;
      });
    },
    onVersionChange(libver) {
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
    },
    getEDIVesion() {
      this.EDIVesionSearchItems.data[0].PARAM = '';
      Store.dispatch('common/getEDIVersionList', this.EDIVesionSearchItems).then(() => {
        for (let i = 0; i < this.EDIVerList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.EDIVerList[i].MSG_VER;
          EDIVerObj.value = this.EDIVerList[i].MSG_VER;
          this.EDIVesionList.push(EDIVerObj);
        }
      });
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ['MSG_NM'],
        data: [
          {
            MSG_NM: '',
          },
        ],
      };
      Store.dispatch('common/getCommonMessageList', commMsgSearchItems).then(() => {
        console.log('--------- Finished to process MES ----------');
        for (let i = 0; i < this.CommMsgList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.CommMsgList[i].MSG_CD + '(' + this.CommMsgList[i].MSG_NM + ')';
          EDIVerObj.value = this.CommMsgList[i].MSG_CD;
          this.EDIMesList.push(EDIVerObj);
        }
      });
    },
    getCode() {
      this.codeSearchItems.data[0].GRP_CODE = 'B06';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.codeItem.push(codeObj);
        }
      });
    },
    /* 2020/10/28 203737 Remove unused source
    clickBrowseMapFile(){
      this.$refs.mapfile_layout_input.click();
    },
    clickBrowseScanFile(){
      this.$refs.scanfile_layout_input.click();
    },*/
    onSave() {
      // 203705_MapManager_Fix issues_9
      let validResult = this.$refs.form.validate();
      if (validResult) {
        if (this.options.item.action == 'add') {
          this.addMapFileLayoutHeader.data[0].MAP_CONV_TP =
            this.map_type_from + '2' + this.map_type_to;
          // CLV-Change Load CODE_CTG_ID from Select Code Table
          this.addMapFileLayoutHeader.data[0].CODE_CTG_ID = this.selectCodeId; // TBD - by April. Please change here for CodeTable
          if (this.isDlb) {
            this.addMapFileLayoutHeader.data[0].LIB_VER = this.libraryVersion;
          } else {
            this.addMapFileLayoutHeader.data[0].LIB_VER = 'for_platform';
          }
          this.addMapFileLayoutHeader.data[0].ORA_VER = this.oracleVersion;
          Store.dispatch('map/saveAddMap', this.addMapFileLayoutHeader).then(() => {
            console.log('--------- Finished to process ----------');
            this.removeDialogRefesh({});
          });
        } else {
          this.updateMapFileLayoutHeader.data[0].MAP_PRCS_NO = this.addMapFileLayoutHeader.data[0].MAP_PRCS_NO;
          this.updateMapFileLayoutHeader.data[0].MAP_NAME = this.addMapFileLayoutHeader.data[0].MAP_NAME;
          this.updateMapFileLayoutHeader.data[0].MAP_MSG_VER = this.addMapFileLayoutHeader.data[0].MAP_MSG_VER;
          this.updateMapFileLayoutHeader.data[0].MAP_MSG_ID = this.addMapFileLayoutHeader.data[0].MAP_MSG_ID;
          this.updateMapFileLayoutHeader.data[0].FFL_PRCS_NO = this.addMapFileLayoutHeader.data[0].FFL_PRCS_NO;
          this.updateMapFileLayoutHeader.data[0].MPD_PRCS_NO = this.addMapFileLayoutHeader.data[0].MPD_PRCS_NO;
          this.updateMapFileLayoutHeader.data[0].CODE_CTG_ID = this.selectCodeId;
          this.updateMapFileLayoutHeader.data[0].MAP_CONV_TP =
            this.map_type_from + '2' + this.map_type_to;
          /*
            2021/01/15 203665 workflow issue 21  send only edit Data to JSON
          */
          let editField = getEditData(this.updateMapFileLayoutHeader.data[0], this.mapData[0]);
          editField.MAP_PRCS_NO = this.addMapFileLayoutHeader.data[0].MAP_PRCS_NO;
          Store.dispatch('map/modifyMapInfo', this.updateMapFileLayoutHeader).then(() => {
            console.log('--------- Finished to process ----------');
            this.sendActivate(this.updateMapFileLayoutHeader.data[0].MAP_PRCS_NO, 'MAP', editField);
            this.removeDialogRefesh({});
          });
        }
      } else {
        if (!this.$refs.refMapName.validate()) {
          this.$refs.refMapName.focus();
        } else if (!this.$refs.refMessage.validate()) {
          this.$refs.refMessage.focus();
        } else if (!this.$refs.refMapTypeForm.validate()) {
          this.$refs.refMapTypeForm.focus();
        } else if (!this.$refs.refMapTypeTo.validate()) {
          this.$refs.refMapTypeTo.focus();
        } else if (!this.$refs.refEdiVersion.validate()) {
          this.$refs.refEdiVersion.focus();
        } else if (!this.$refs.refMapperComt.validate()) {
          this.$refs.refMapperComt.focus();
        }
        return validResult;
      }
    },

    sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      this.$store
        .dispatch('updateProcessInfo', params)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log('error when send update to kafka');
        });
    },
    onFlatFileChanged(e) {
      this.addMapFileLayoutHeader.data[0].MAPPER_NAME = e.target.files[0].name;
      this.addMapFileLayoutHeader.data[0].mappfile = e.target.files[0];
    },
    onCsvFileChanged(e) {
      this.addMapFileLayoutHeader.data[0].SCANNER_NAME = e.target.files[0].name;
      this.addMapFileLayoutHeader.data[0].scanfile = e.target.files[0];
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      this.$emit('search');
    },
    removeDialog(dialog) {
      // dialog.id = this.id;
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    openFlatFileLayoutList() {
      EventBus.$emit('openFlatFileLayoutList', this.addMapFileLayoutHeader.data[0].FFL_FILE_NAME);
    },
    openMappingDefinitionList() {
      EventBus.$emit('openMappingDefinitionList', this.mapDefinitionFileName);
    },
    updateFlatFile(item) {
      this.addMapFileLayoutHeader.data[0].FFL_FILE_NAME = item.FFL_FILE_NAME;
      this.addMapFileLayoutHeader.data[0].FFL_PRCS_NO = item.FFL_PRCS_NO;
    },
    updateMapDefinitionFile(item) {
      this.mapDefinitionFileName = item.MPD_FILE_NAME;
      this.addMapFileLayoutHeader.data[0].MPD_PRCS_NO = item.MPD_PRCS_NO;
    },
    filterMapType(item) {
      if (item == 'E' || item == 'A' || item == 'X' || item == 'J') {
        if (item == 'E' || item == 'A') {
          this.$refs.eDI_version.classList.add('mandatory');
          this.icon = true;
        } else {
          this.$refs.eDI_version.classList.remove('mandatory');
          this.icon = false;
        }
        this.disable_Scan = false;
        this.addMapFileLayoutHeader.data[0].SCANNER_NAME = '';
        this.addMapFileLayoutHeader.data[0].SCANNER_FILE_ID = '';
        this.addMapFileLayoutHeader.data[0].SCANNER_SIZE = '';
      } else {
        this.$refs.eDI_version.classList.remove('mandatory');
        this.icon = false;
        this.disable_Scan = true;
      }
    },
    changeEdiList() {
      // this.getEDIMsgTypeList(); // mod by April. No need to connect. 2020.07.20
    },
    /* 2020/10/28 203737 Remove unused source
    createValidateObj(data1,data2){
       let a ={};
       a.text=data1;
       a.value= data2;
       return a;
    },*/
    openCodeTableDialog() {
      EventBus.$emit('openCodeTableDialog', this.selectCodeId);
    },
    updateSelectCodeTitle(item) {
      this.selectCodeName = item.CODE_CTG_NAME;
      this.selectCodeId = item.CODE_CTG_ID;
    },
    openLoadFilePop(item) {
      let { mode, filetype } = item;
      if (mode == 'Load') {
        let callback = (row) => {
          Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {
            if (filetype == 'mapper') {
              this.addMapFileLayoutHeader.data[0].MAPPER_NAME = row.USR_FILE_NAME;
              this.addMapFileLayoutHeader.data[0].MAPPER_FILE_ID = row.FILE_ID;
              this.addMapFileLayoutHeader.data[0].MAPPER_SIZE = row.USR_FILE_SIZE;
              this.fileLoaded = row;
            } else if (filetype == 'scanner') {
              this.addMapFileLayoutHeader.data[0].SCANNER_NAME = row.USR_FILE_NAME;
              this.addMapFileLayoutHeader.data[0].SCANNER_FILE_ID = row.FILE_ID;
              this.addMapFileLayoutHeader.data[0].SCANNER_SIZE = row.USR_FILE_SIZE;
              this.scannerLoaded = row;
            }
          });
        };
        this.$emit('openLoadFile', { mode: 'Load', filetype: filetype, callback });
      }
    },
    downloadCodeList(codeListId) {
      this.codeListCreate.data[0].CODE_CTG_ID = codeListId;
      this.codeListCreate.data[0].SITE_CODE = $cookies.get('comp-id');
      this.codeListCreate.data[0].SUB_DIR = this.mapData[0].MAP_NAME;
      Store.dispatch('map/createCodeList', this.codeListCreate).then(() => {
        if (this.codeListResult[0].successFlag === 'SUCCESS') {
          let downloadfile = new DownloadFile();
          downloadfile.data[0].FILE_ID = this.codeListResult[0].returnFileID;
          downloadfile.data[0].SAVE_NAME = 'code_list.txt';
          Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
            console.log('--------- Finished to process ----------');
          });
        }
      });
    },
    save() {},
    closeComDialog() {
      this.checkDataChange();
    },
    checkDataChange() {
      this.removeDialog();
      // let editedData = this.getEditData(this.addMapFileLayoutHeader.data[0], this.loadFormData);
      // if(Object.keys(editedData).length !== 0) {
      //   this.$refs.confirmDialog.dialog = true;
      // } else {
      //   this.removeDialog();
      // }
    },
  },
};
</script>

<style></style>
